import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { LessonFacade } from '@app/store/lesson';
import { AssignmentsFacade } from '@app/store/assignments';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly lessonFacade = inject(LessonFacade);
    private readonly assignmentsFacade = inject(AssignmentsFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly lessonId = input.required<string>();
    readonly saving = input<boolean>(false);

    readonly hasAssignments = computed(() => this.assignmentsFacade.assignments(this.lessonId(), 'lesson')().length > 0);

    constructor() {
        effect(() => {
            this.assignmentsFacade.getAssignments(this.lessonId(), 'lesson');
        });
    }

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('lessons.delete.header'),
            message: this.translateService.instant('lessons.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('lessons.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('lessons.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.lessonFacade.deleteLesson(this.lessonId());
            },
        });
    }
}
